<template>
  <div class="main-wrapper --auth-layout">
    <div class="main-row">
      <div class="main-container">
        <aside
          v-show="!store.state.system.isAsideHidden"
          :class="{ '--hide-mobile': isLogoHidden }"
          class="main-header"
        >
          <img
            class="main-header__logo"
            :src="configDataDefaultBrand.assets.logo"
            alt="Логотип"
          />
          <img
            class="main-header__logo_mobile"
            :src="configDataDefaultBrand.assets.mobileLogo"
            alt="Логотип"
          />
        </aside>
        <main class="main-slot">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from "@/store";
import { computed } from "vue";

const store = useStore();
const isLogoHidden = computed(() => store.state.system.isLogoHidden);

const configDataDefaultBrand = computed(
  () => store.getters["brand/configDataDefaultBrand"]
);
</script>

<style lang="scss" scoped>
.main {
  &-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: var(--app-height);

    // На мобильных экран авторизации не должен скроллиться целиком:
    // за скролл отвечает .form-screen__body внутри шага.
    @media (max-width: 768px) {
      height: var(--app-height);
      max-height: var(--app-height);
      min-height: 0;
      overflow: hidden;
    }
  }

  &-row {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
    width: 100%;
  }

  &-container {
    display: flex;
    flex: 1;
    flex-flow: row;
    position: relative;
    width: 100%;
    @media (max-width: 960px) {
      flex-direction: column;
    }
  }

  &-header {
    position: absolute;
    top: 44px;
    left: 41px;
    z-index: 4;
    min-width: 260px;

    //padding: 44px 0 0 41px;

    @media (max-width: 1100px) {
      //padding: 44px 0 0 20px;
    }

    @media (max-width: 960px) {
      display: flex;
      justify-content: center;
      position: static;
      width: 100%;
      flex-direction: column;
    }

    @media (max-width: 960px) {
      display: flex;
      align-items: center;
      padding: 0;
    }
    &.--hide-mobile {
      @media (max-width: 650px) {
        display: none;
      }
    }
    &__logo {
      max-width: 71px;
      width: 100%;
      height: auto;

      @media (max-width: 960px) {
        display: none;
      }

      &_mobile {
        display: none;

        @media (max-width: 960px) {
          display: flex;
          position: absolute;
          top: 13px;
          left: 25px;
        }
      }
    }
  }

  &-slot {
    display: flex;
    flex: 1;
    // align-items: flex-start;
    justify-content: center;
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
  }
}
</style>
